<template>
  <div class="product-list-container">
    <div class="header">{{ recipient.first_name }}</div>
    <nav class="add-navigation flex flex-wrap">
      <div @click="$router.push({name: 'company-admin-recipients'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p class="white_space">Back to Recipients</p>
      </div>
      <div class="buttons-wrapper flex-wrap">
        <div @click="$router.push({name: 'company-admin-recipients'})" class="secondary-button my-2 my-md-0">
          <secondary-button class="button_size">Cancel</secondary-button>
        </div>
        <div class="first button-container my-2 my-md-0">
          <primary-button @click.native="editRecipient" class="button">Save Recipient</primary-button>
        </div>
      </div>
    </nav>
    <div class="row p-2 mb-2">
             <div class="col-md-3 col-12">

        <primary-input
          v-model="recipient.first_name"
          name="first name"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('first name')}"
        />
        <div v-if="errors.has('first name')" class="help is-danger">{{ errors.first('first name') }}</div>
        <div
          class="help is-danger"
          v-if="errorsArray"
        >{{errorsArray.first_name ? errorsArray.first_name[0] : null}}</div>
      </div>
             <div class="col-md-3 col-12">
        <primary-input
          v-model="recipient.last_name"
          name="last name"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('last name')}"
        />
        <div v-if="errors.has('last name')" class="help is-danger">{{ errors.first('last name') }}</div>
        <div
          class="help is-danger"
          v-if="errorsArray"
        >{{errorsArray.last_name ? errorsArray.last_name[0] : null}}</div>
      </div>
             <div class="col-md-3 col-12">
        <primary-input
          name="phone number"
          v-model="recipient.phone_number"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('phone number')}"
        />
        <div
          v-if="errors.has('phone number')"
          class="help is-danger"
        >{{ errors.first('phone number') }}</div>
        <div
          class="help is-danger"
          v-if="errorsArray"
        >{{errorsArray.phone_number ? errorsArray.phone_number[0] : null}}</div>
      </div>
             <div class="col-md-3 col-12">
        <primary-input
          name="address"
          v-model="recipient.address"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('address')}"
        />
        <div v-if="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</div>
        <div
          class="help is-danger"
          v-if="errorsArray"
        >{{errorsArray.address ? errorsArray.address[0] : null}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton"),
  },
  data: () => ({
    recipient: {
      phone_number: null,
      last_name: null,
      first_name: null,
      address: null,
    },
    errorsArray: null,
  }),
  created() {
    this.$store.dispatch("GetRecipient", this.$route.params.id).then((res) => {
      const { phone_number, last_name, first_name, address } = res;
      this.recipient = { phone_number, last_name, first_name, address };
    });
  },
  methods: {
    editRecipient() {
      this.$store
        .dispatch("EditRecipient", {
          recipient: this.recipient,
          recipient_uuid: this.$route.params.id,
        })
        .then(() => {
          this.$router.push({ name: "company-admin-recipients-list" });
          this.$success("Recipient has been edited");
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.errorsArray = err.response.data.errors[0];
            setTimeout(() => {
              this.errorsArray = null;
            }, 6000);
          } else {
            this.$snotify.error(err.response.data.error.message, {
              timeout: 4000,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-container {
  padding: 0 20px;

  .header {
    //padding: 15px 0;
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .button-container {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      .button {
        height: 40px;
        width: 160px;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 145px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .table {
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    justify-content: space-between;

    .first {
      min-width: fit-content;
      width: calc(20% - 7.5px);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .button-container {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      .button {
        margin-top: 20px;
        height: 40px;
        width: 130px;
      }
    }
  }
}
.row .input{
  margin-top: 20px;
}
@media (max-width: 369px) {
  .button_size{
    min-width:160px ;

  }

}
</style>

